/**
 * The last shooter called from the roster (REF-18). Calling opens the Score
 * screen right away, so the undo is offered there first and again on the
 * roster when the referee comes back. Module scope so it survives the
 * unmounts. Only server-confirmed calls land here — an offline roster tap
 * never queues a call. Cleared once an undo was used, so the two screens
 * never both offer it for the same call.
 */
export interface RosterCall {
  assignmentId: string;
  label: string;
  /** Date.now() of the call. */
  at: number;
}

let lastRosterCall: RosterCall | null = null;

export function setLastRosterCall(call: RosterCall | null): void {
  lastRosterCall = call;
}

export function getLastRosterCall(): RosterCall | null {
  return lastRosterCall;
}
